import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { translation } from '../../utils/PageInfoTranslator';

// ====

const SEO = (props) => {
  const { meta, settings, href, openGraph, mode } = props;

  const page = translation(meta, openGraph, settings);

  return (
    <Helmet>
      <title>{page.pageTitle}</title>
      <link rel="canonical" href={`${page.url}`} />
      <meta name="description" content={page.description} />
      {page.url && <meta property="og:url" content={`${page.url}`} />}
      {page.type && <meta property="og:type" content={page.type} />}
      {page.title && <meta property="og:title" content={page.title} />}
      {page.description && (
        <meta property="og:description" content={page.description} />
      )}
      {page.siteName && (
        <meta property="og:site_name" content={page.siteName} />
      )}
      {page.image && <meta property="og:image" content={page.image} />}
      {page.image && <meta property="og:image:alt" content={page.title} />}
      {page.image && <meta property="og:image:width" content="960" />}
      {page.image && <meta property="og:image:height" content="540" />}
      {page.author && <meta property="og:author" content={page.author} />}
      {settings.twitter && (
        <meta name="twitter:site" content={settings.twitter} />
      )}
      {page.author && <meta name="twitter:creator" content={page.author} />}
      <meta name="twitter:card" content="summary_large_image" />
      {openGraph.noIndex === true && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default SEO;

SEO.propTypes = {
  mode: PropTypes.string,
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  openGraph: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SEO.defaultProps = {
  mode: 'helmet',
  meta: null,
  settings: null,
  openGraph: {
    title: '',
    description: '',
    author: '',
    image: '',
    type: 'website',
  },
};

//      <meta name="twitter:card" content="summary_large_image" />      <p>Output: {JSON.stringify(ogDescription)}</p>
